import { ClusterFilterPipe } from './table.pipe';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { TableService } from './table.service';
import { ModalComponent } from '../../shared/modal/modal.component';
import { MODAL_MESSAGES } from '../../shared/constants';
import { VW_UNITS, CLUSTERS } from '../../shared/constants';

@Component({
  selector: 'cms-table',
  templateUrl: './table.component.html',
  styleUrls: [
    './table.component.scss'
  ],
  providers: [
    TableService
  ]
})

export class TableComponent implements OnInit {
  @ViewChild(ModalComponent) nModal: ModalComponent;
  area: string;
  itens: any[];
  itensFilter: any[];
  headers: any;
  classes = {};
  selected = [];
  //query variables
  page = 1;
  headerSort='';
  orderBy='';
  //pagination variables
  maxSize: number = 5;
  totalItems: number;
  currentPage: number;
  limit: number;

  unidades: Array<any> = [];
  clusterFilter: Array<any> = ['Todas'];
  clusters: Array<any> = CLUSTERS;
  comboFilter: string;

  tempItems: any[];

  link: string;

  selectedUnit = 'all';
  selectedCategory = 'Todas';

  constructor(
    private _route: Router,
    private tableService: TableService
  ) {}

  ngOnInit(): void{
    this.area = this._route.url;
    this.area = this.area.substr(1,this.area.length);

    for (let i in this.clusters)
      this.clusterFilter.push(this.clusters[i]);

    if (this.area == 'menu')
      this.comboFilter = 'vw-anchieta';
    if (this.area == 'faq') {
      this.comboFilter = this.clusterFilter[0];
      this.unidades = [{NAME: 'Todas', VALUE: 'all'}];
      for (let i in VW_UNITS)
        this.unidades.push(VW_UNITS[i]);
    } else {
      this.unidades = VW_UNITS;
    }

    this.getList(this.area, true);
  }

  sortBy(header: string){
    this.headerSort = header;
    this.classes[header] = !this.classes[header];
    for(let i in this.selected) {
      this.selected[i] = false;
    };
    this.selected[header] = true;
    this.orderBy = (this.classes[header])? 'desc' : 'asc';
    let query: string = '?page=1&limit='+this.limit+'&orderField='+this.headerSort+'&orderBy='+ this.orderBy;

    this.getList(this.area, false, query);
  }

  public pageChanged(event:any): void {
    this.page = event.page;
    let query: string = '?page='+this.page+'&limit='+this.limit+'&orderField='+this.headerSort+'&orderBy='+ this.orderBy;
    this.getList(this.area, false, query);
  }

  getList(area: string, initial: boolean, query?: string){
    query = (query == undefined)? '': query;
    switch(area){
      case "news":
        this.link = '/news';
        if(initial) {
          this.headers = this.tableService.getNewsHeaders();
          this.headers.forEach(header => {
            this.classes[header.attr]= header.orderBy;
            this.selected[header.attr]= header.orderBy;
          });
        }
        this.tableService.getNews(query)
          .then(news => {
            this.itens = news.docs;
            this.totalItems = news.total;
            this.limit = news.limit;
            this.currentPage = news.page;
          })
          .catch(err => {
            console.log(err);
          });
        break;
      default:
        //error
        break;
    }
  }

  filterTable($event, isUnit?: boolean) {
    this.comboFilter = $event.target.value;

    if (this.area == 'faq') {

      if (isUnit) {
        this.selectedUnit = $event.target.value;
      } else {
        this.selectedCategory = $event.target.value;
        // let pipe = new ClusterFilterPipe().transform(this.itens, [this.selectedCategory]);
        // this.tempItems = pipe;
      }

      this.itens = this.itensFilter.filter((item) => {
        if (this.selectedCategory == 'Todas' && this.selectedUnit == 'all') {
          return this.itensFilter;
        } else if (this.selectedCategory == 'Todas' && this.selectedUnit != 'all') {
          return (item.units.includes(this.selectedUnit));
        } else if (this.selectedCategory != 'Todas' && this.selectedUnit == 'all') {
          return (item.cluster.toLocaleLowerCase().includes(this.selectedCategory.toLocaleLowerCase()));
        } else {
          return (item.units.includes(this.selectedUnit) &&
            (item.cluster.toLocaleLowerCase().includes(this.selectedCategory.toLocaleLowerCase())));
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/table/table.component.ts